import React from "react";
import PdfIcon from "../../../../assets/images/view_pdf.svg";
import styles from "./PDFOption.module.scss";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";
import clsx from "clsx";
import { message, Popover } from "antd";
import alertIcon from "../../../../assets/images/alert-red.svg";
import archiveIcon from "../../../../assets/images/delete-contact-icon.svg";
import archiveEllipsis from "../../../../assets/images/archiveEllipsis.svg";
import { PlacementPositions } from "../../../../enums/PlacementPositionsEnums";
import { PopoverTrigger } from "../../../../enums/PopoverEnums";
import { PDFOptionConstants } from "../constants";
import TicketProcessingServices from "../../../../services/ticketProcessing.service";
import { archiveTicketMessages, imageAltProps } from "./constants";
import TNLoader from "../../../../reusable-components/TNLoader";

interface SubmissionDataType {
  currentSubmissions?: number;
  currentUsers?: number;
  uniqueSubmissions?: number;
  uniqueUsers?: number;
}

interface PDFOptionProps {
  id?: string;
  name: string;
  uploadDate: string;
  isSubmitted: boolean;
  isManagerReview?: boolean;
  showAlert?: boolean;
  isActive?: boolean;
  onClick?: () => void;
  submissionData?: SubmissionDataType;
}

const PDFOption = (props: PDFOptionProps) => {
  const {
    id,
    name,
    uploadDate,
    isSubmitted,
    isManagerReview = false,
    showAlert = false,
    isActive = false,
    onClick,
    submissionData,
  } = props;

  const { pdfIconAlt, alertIconAlt, archiveEllipsisAlt, archiveIconAlt } =
    imageAltProps;

  const { ArchiveTicket } = TicketProcessingServices();
  const { mutateAsync: archiveTicket, isPending: archiveTicketPending } =
    ArchiveTicket();

  const handleArchiveTicket = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    await archiveTicket(
      {
        id: id,
      },
      {
        onSuccess: () => message.success(archiveTicketMessages.success),
        onError: () => message.error(archiveTicketMessages.failure),
      },
    );
  };

  return (
    <>
      <TNLoader isLoading={archiveTicketPending} />
      <div
        className={clsx(styles.pdfOptionWrapper, {
          [styles.pdfOptionWrapperDisabled]: isSubmitted,
          [styles.pdfOptionWrapperActive]: isActive,
        })}
        onClick={onClick}
      >
        <img className={styles.pdfOptionIcon} src={PdfIcon} alt={pdfIconAlt} />
        <div className={styles.pdfOptionText}>
          <div className={styles.pdfOptionTextHeader}>
            <p className={styles.pdfOptionName}>{name}</p>
            {showAlert && <img src={alertIcon} alt={alertIconAlt} />}
          </div>
          <p className={styles.pdfOptionDate}>{uploadDate}</p>
          <ConditionalRender visible={isSubmitted}>
            <div className={styles.submissionStats}>
              <div className={styles.pdfOptionCount}>
                <span>{PDFOptionConstants.USER_TXT}</span>
                <div>{`${submissionData?.currentUsers}`}</div>
              </div>
              <div className={styles.pdfOptionCount}>
                <span>{PDFOptionConstants.TKT_SUBMISSION_TXT}</span>
                <div>{`${submissionData?.currentSubmissions}/${submissionData?.uniqueSubmissions}`}</div>
              </div>
            </div>
          </ConditionalRender>
        </div>
        <ConditionalRender visible={isManagerReview}>
          <Popover
            trigger={PopoverTrigger.HOVER}
            overlayClassName={styles.archiveOptionWrapper}
            placement={PlacementPositions.BOTTOM}
            content={
              <div
                onClick={(e) => handleArchiveTicket(e)}
                className={styles.archiveEllisisContent}
              >
                <img src={archiveIcon} alt={archiveIconAlt} />
                <span className={styles.archiveOptionText}>
                  {PDFOptionConstants.ARCHIVE_OPTION_TEXT}
                </span>
              </div>
            }
          >
            <img
              className={styles.archiveEllipsis}
              src={archiveEllipsis}
              alt={archiveEllipsisAlt}
            />
          </Popover>
        </ConditionalRender>
      </div>
    </>
  );
};

export default PDFOption;
